import { config } from './config';
import { carryParams } from './utils';

interface RedirectParams {
  voiceId?: string;
  textContent?: string;
  prompt?: string;
  destination?: string;
}

export const redirectToOnboardingCheckout = (params?: RedirectParams) => {
  const url = new URL(config.onboarding.baseUrl);
  const onboardingPageBaseUrl = url.origin + '/sign-up';

  const extraParams: Record<string, string> = {
    src: 'vo-demo',
    redirectTo: params?.destination ?? 'scratchpad',
  };

  if (params?.voiceId) {
    extraParams.voiceId = params.voiceId;
  }
  if (params?.textContent) {
    extraParams.text = params.textContent.substring(0, 500);
  }
  if (params?.prompt) {
    extraParams.prompt = params.prompt;
  }
  const redirectUrl = carryParams(onboardingPageBaseUrl, extraParams);
  window.open(redirectUrl, '_blank');
};
